import _trim from 'lodash/trim';
// @ts-expect-error TS(7006): Parameter 'styleText' implicitly has an 'any' type... Remove this comment to see the full error message
export default function parsedStyle(styleText) {
  if (!styleText) {
    return null;
  }

  const elements = styleText.split(';');
  const parsedStyle = {};
  // @ts-expect-error TS(7006): Parameter 'element' implicitly has an 'any' type.
  elements.forEach(element => {
    if (!element) {
      return null;
    }

    const trimmedElement = _trim(element);

    const splitElement = trimmedElement.split(':');
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    parsedStyle[_trim(splitElement[0])] = _trim(splitElement[1]);
  });
  return parsedStyle;
}
